import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    heading: {
        fontSize: '22px',
        color: '#272727',
        opacity: '1',
        marginTop: '5px',
        marginBottom: '5px',
        fontWeight: '600',
        fontFamily: 'Lato, sans-serif !important'
    },
    registrationLink: {
        color: '#55C6FE',
        font: 'normal normal normal 12px/18px Montserrat',
        letterSpacing: '0px',
        opacity: '1',
    },
    row: {
        font: 'normal normal normal 12px/18px Montserrat',
        letterSpacing: '0px',
        color: '#4E4E4E',
        marginBottom: '0px',
        marginTop: '0px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    clientName: {
        textDecoration: 'underline',
        font: 'normal normal normal 12px/15px Montserrat',
        letterSpacing: '0px',
        color: '#55C6FE',
    },
    tenantNameContainer: {
        font: 'normal normal normal 10px/14px Open Sans',
        letterSpacing: '0px',
        backgroundColor: '#E0E0E0',
        width: 'max-content',
        padding: '1px 6px',
        border: '1px solid #E0E0E0',
        borderRadius: '12px',
        margin: '8px 0px',
    },
    tenantName: {
        margin: '0px',
        color: '#707070',
    },
    table: {
        marginTop: '15px',
        border: '0px !important',
    },
    '.MuiDataGrid-root .MuiDataGrid-cell': {
        marginTop: '0px !important',
    },
    customerDetailsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
    },
    customerAccessContainer: {
        border: '1px solid #E0E0E0',
        borderRadius: '12px',
        padding: '20px',
    },
    customPagination: {
        '& .MuiPagination-root .MuiPagination-ul': {
            flexWrap: 'nowrap'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child svg, & .MuiPagination-root .MuiPagination-ul li:last-child svg':
        {
            display: 'none'
        },
        '& .MuiPagination-root .MuiPagination-ul li:last-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child > button, & .MuiPagination-root .MuiPagination-ul li:last-child > button::before':
        {
            margin: '0px 5px'
        },
        paddingTop: '20px'
    },
    showPaginationDesc: {
        float: 'left',
        position: 'absolute',
        left: '0px'
    },
    pageItem: {
        border: '1px solid #E9EBF0 !important',
        margin: '0px !important',
        borderRadius: '0px !important',
        height: '32px !important',
        '& button::after': {
            margin: '0px'
        }
    },
    emptyList: {
        padding: '20px 0px',
    },
    tableSearchIcon: {
        width: '20px !important',
        height: '20px !important',
        marginBottom: '2px'
    },
    headerIcon: {
        fontSize: 25,
        color: 'rgba(255, 255, 255, 1.0)'
    },
    searchTextField: {
        marginTop: '12px'
    },
    resize: {
        fontSize: `${theme.palette.textSizeLarge} !important`
    },
    emptyDataText: {
        font: 'normal normal bold 18px/24px Open Sans',
        letterSpacing: '0px',
        color: '#707070',
        opacity: 1,
    }
}));
